import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import Hamburger from 'hamburger-react';
import { BsDot } from 'react-icons/bs';
import $ from 'jquery';
import * as sisMapActions from "store/modules/rds_sisMap";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { withRouter } from "react-router-dom";

import stl from './DefaultHeader.module.scss';
class DefaultHeader extends Component {

    state = {
        hamburgerCondition: false,
        headerNavLink: this.props.headerNavLink,
        isPage: this.props.target === 'main' ? false : true,
        categoryName: '',
        subCategory: '',
        constructionYN: null
    }

    componentDidMount() {
        if (this.state.headerNavLink == 'reference') {
            $('a[href="/reference"]').css({
                color: '#0921b5',
                borderBottom: '3px solid #0921b5'
            });
            this.setState({
                categoryName: '통계연보',
            })
        } else if (this.state.headerNavLink == 'info') {
            $(`a.${stl.navItem}[href="/notice"]`).css({
                color: '#0921b5',
                borderBottom: '3px solid #0921b5'
            });
            this.setState({
                categoryName: '이용안내',
            })
        } else if (this.state.headerNavLink == 'notice') {
            $(`a.${stl.navItem}[href="/notice"]`).css({
                color: '#0921b5',
                borderBottom: '3px solid #0921b5'
            });
            this.setState({
                categoryName: '공지사항',
            })
        }
        this.containerRef = React.createRef(); // div ref 생성
        this.callUserConfig();
    }

	//사용자 IP 가져오기
    callUserConfig = () => {
        fetch('/api/com/user/config')
            .then(response => response.json())
            .then(data => {
                //if (data.javaIp == "211.253.121.18" || data.javaIp == "211.253.121.34")
                if (data.javaIp === "211.253.121.18" || data.javaIp === "211.253.121.34" || data.javaIp === "127.0.0.1" || data.javaIp === "10.30.0.63") {
                    this.setState({
                        constructionYN: 'N'
                    });
                } else {
                    this.setState({
                        constructionYN: 'N'
                    });
                }
                //console.log("자바함수 : " + data.javaIp + " , 리퀘스트 : " + data.clientIp)
            })
    }

    subMenuCategory = (category) => {
        console.log(category);
        //여긴 사용안하는 것 같음
        this.setState({
            subCategory: category,
        });
        if (category == '공지사항'){
            //alert("hi");
            //window.location.href = '/notice'
            return;
        }else if (category == '이용안내'){
            //window.location.href = '/info'
            return;
        }

        const { SisMapActions } = this.props;
        let target = '';

        if(category == '인구'){
            target = 'population';
        }else if(category == '교통'){
            target = 'transportation';
        }else if(category == '생활'){
            target = 'living';
        }else if(category == '복지'){
            target = 'welfare';
        }else if(category == '보건'){
            target = 'sanitary';
        }else if(category == '문화'){
            target = 'culture';
        }else if(category == '안전'){
			target = 'safety';
		}else if(category == '부동산'){
			target = 'weather';
		}else if(category == '건설사업'){
			target = 'construction';
		}
        SisMapActions.mainCategory(target);
        this.props.history.push("/mapMain");
    }

    isHamburger = () => {
        this.setState({
            hamburgerCondition: !this.state.hamburgerCondition
        })
    }
    
    closeMobileNav = () => {
        this.setState({ hamburgerCondition: false });
    };


    render() {
        return (
            <>
                <div id={stl.defaultHeader}>
                    <div className={stl.headerWrapper}>
                        <NavLink className={`${stl.left} ${stl.logo}`} to="/">
                            <span style={{display:'none'}}>헤더 로고</span>
                        </NavLink>

                        <ul className={stl.desktopNav}>
                            <li className={stl.liNavItem}>
                                <NavLink className={stl.navItem} to="/notice" aria-haspopup="true">
                                    알림글
                                    <img className={stl.navImg} src="/sis/images/main/menuArrowDown.png" alt="하위메뉴 열기" />
                            </NavLink>

                                <div className={stl.hoverDiv}>
                                    <ul className={stl.subMenu}>
                                    <li>
                                            <NavLink to={{ pathname: "/notice" }}>공지사항</NavLink>
                                    </li>
                                    <li>
                                            <NavLink to={{ pathname: "/info" }}>이용안내</NavLink>
                                    </li>
                                </ul>
                            </div>
                        </li>

                            <li className={stl.liNavItem}>
                                <NavLink className={stl.navItem} to="/mapMain" aria-haspopup="true">
                                    분야별지도
                                    <img className={stl.navImg} src="/sis/images/main/menuArrowDown.png" alt="하위메뉴 열기" />
                            </NavLink>

                                <div className={stl.hoverDiv}>
                                    <ul className={stl.subMenu}>
                                        <li><NavLink to={{ pathname: "/mapMain", aboutProps: 'population' }}>인구</NavLink></li>
                                        <li><NavLink to={{ pathname: "/mapMain", aboutProps: 'transportation' }}>교통</NavLink></li>
                                        <li><NavLink to={{ pathname: "/mapMain", aboutProps: 'living' }}>생활</NavLink></li>
                                        <li><NavLink to={{ pathname: "/mapMain", aboutProps: 'welfare' }}>복지</NavLink></li>
                                        <li><NavLink to={{ pathname: "/mapMain", aboutProps: 'sanitary' }}>보건</NavLink></li>
                                        <li><NavLink to={{ pathname: "/mapMain", aboutProps: 'culture' }}>문화</NavLink></li>
                                        <li><NavLink to={{ pathname: "/mapMain", aboutProps: 'safety' }}>안전</NavLink></li>
                                        <li><NavLink to={{ pathname: "/mapMain", aboutProps: 'realEstate' }}>부동산</NavLink> </li>
                                        {this.state.constructionYN === 'Y' && (
                                            <li><NavLink to={{ pathname: "/mapMain", aboutProps: 'construction' }}>건설사업</NavLink></li>
                                    )}
                                </ul>
                            </div>
                        </li>

                            <li className={stl.liNavItem}>
                                <button type="button" className={stl.navItem} aria-haspopup="true">
                                    연계정보
                                    <img className={stl.navImg} src="/sis/images/main/menuArrowDown.png" alt="하위메뉴 열기" />
                                </button>

                            <div className={stl.hoverDiv}>
                                <ul className={stl.subMenu}>
                                    <li>
                                        <a href="https://jeonnam-gwangju.go.kr/" target="_blank" rel="noopener noreferrer">전남광주통합특별시</a>
                                    </li>
                                    <li>
                                        <a href="https://map.jeonnam.go.kr/main" target="_blank" rel="noopener noreferrer">공간정보참여마당</a>
                                    </li>
                                    <li>
                                        <a href="https://tour.jeonnam-gwangju.go.kr" target="_blank" rel="noopener noreferrer">비짓전남광주</a>
                                    </li>
                                    <li>
                                        <a href="https://bigdata.jeonnam-gwangju.go.kr/tour/index.html#/tour/mapservice?1" target="_blank" rel="noopener noreferrer">관광빅데이터분석</a>
                                    </li>
                                    <li>
                                        <a href="https://seereal.lh.or.kr/main.do" target="_blank" rel="noopener noreferrer">SEE:REAL</a>
                                    </li>
                                    <li>
                                       <a href="https://map.vworld.kr/map/maps.do" target="_blank" rel="noopener noreferrer">3차원지도</a>
                                    </li>
                                </ul>
                            </div>
                        </li>

                            <li className={stl.liNavItem}>
                                <NavLink className={stl.navItem} to="/reference">
                            통계연보
                        </NavLink>
                            </li>
                        </ul>
                    </div>

                    <div className={stl.hamburger}>
                        <Hamburger toggled={this.state.hamburgerCondition} toggle={this.isHamburger} size={26} label="메뉴 열기 또는 닫기" />
                    </div>

                    <nav className={`${stl.mobileNav} ${this.state.hamburgerCondition ? stl.active : stl.none}`} aria-label="모바일 메뉴" aria-hidden={!this.state.hamburgerCondition} >
                        <div className={stl.mobileNavHeader}>메뉴</div>

                        <details className={stl.mobileGroup}>
                            <summary>알림글</summary>
                            <ul className={stl.mobileSubMenu}>
                                <li><NavLink to="/notice" onClick={this.closeMobileNav}>공지사항</NavLink></li>
                                <li><NavLink to="/info" onClick={this.closeMobileNav}>이용안내</NavLink></li>
                            </ul>
                        </details>

                        <details className={stl.mobileGroup}>
                            <summary>분야별지도</summary>
                            <ul className={stl.mobileSubMenu}>
                                <li><NavLink to={{ pathname: "/mapMain", aboutProps: 'population' }} onClick={this.closeMobileNav}>인구</NavLink></li>
                                <li><NavLink to={{ pathname: "/mapMain", aboutProps: 'transportation' }} onClick={this.closeMobileNav}>교통</NavLink></li>
                                <li><NavLink to={{ pathname: "/mapMain", aboutProps: 'living' }} onClick={this.closeMobileNav}>생활</NavLink></li>
                                <li><NavLink to={{ pathname: "/mapMain", aboutProps: 'welfare' }} onClick={this.closeMobileNav}>복지</NavLink></li>
                                <li><NavLink to={{ pathname: "/mapMain", aboutProps: 'sanitary' }} onClick={this.closeMobileNav}>보건</NavLink></li>
                                <li><NavLink to={{ pathname: "/mapMain", aboutProps: 'culture' }} onClick={this.closeMobileNav}>문화</NavLink></li>
                                <li><NavLink to={{ pathname: "/mapMain", aboutProps: 'safety' }} onClick={this.closeMobileNav}>안전</NavLink></li>
                                <li><NavLink to={{ pathname: "/mapMain", aboutProps: 'realEstate' }} onClick={this.closeMobileNav}>부동산</NavLink></li>
                                {this.state.constructionYN === 'Y' && (
                                    <li><NavLink to={{ pathname: "/mapMain", aboutProps: 'construction' }} onClick={this.closeMobileNav}>건설사업</NavLink></li>
                                )}
                            </ul>
                        </details>

                        <details className={stl.mobileGroup}>
                            <summary>연계정보</summary>
                            <ul className={stl.mobileSubMenu}>
                                <li>
                                    <a href="https://jeonnam-gwangju.go.kr/" target="_blank" rel="noopener noreferrer">전남광주통합특별시</a>
                                </li>
                                <li>
                                    <a href="https://map.jeonnam.go.kr/" target="_blank" rel="noopener noreferrer">공간정보참여마당</a>
                                </li>
                                <li>
                                    <a href="https://tour.jeonnam-gwangju.go.kr" target="_blank" rel="noopener noreferrer">비짓전남광주</a>
                                </li>
                                <li>
                                    <a href="https://bigdata.jeonnam-gwangju.go.kr/tour/index.html#/tour/mapservice?1" target="_blank" rel="noopener noreferrer">관광빅데이터분석</a>
                                </li>
                                <li>
                                    <a href="https://seereal.lh.or.kr/main.do" target="_blank" rel="noopener noreferrer">SEE:REAL</a>
                                </li>
                                <li>
                                    <a href="https://map.vworld.kr/map/maps.do" target="_blank" rel="noopener noreferrer">3차원지도</a>
                                </li>
                            </ul>
                        </details>

                        <NavLink className={stl.navItem} to="/reference" onClick={this.closeMobileNav}>
                            통계연보
                        </NavLink>
                    </nav>
                </div>

                {
                    this.state.isPage &&
                    <div id={stl.breadcrumbs}>
                        <div className={stl.wrapper}>
                            <div id={stl.nav}>
                                {this.state.categoryName === '공지사항' || this.state.categoryName === '이용안내' ?
                                    <>
                                        <img alt="홈" src='/sis/images/main/board/navHome.png' id={stl.navHome} />
                                        &nbsp;&nbsp;
                                        <img alt="" src='/sis/images/main/board/navNext.png' id={stl.navNext} />
                                        &nbsp;&nbsp;알림글&nbsp;&nbsp;
                                        <img alt="" src='/sis/images/main/board/navNext.png' id={stl.navNext} />
                                        &nbsp;&nbsp;
                                        <span id={stl.navText}>{this.state.categoryName}</span>
                                    </>
                                     :
                                    <>
                                        <img alt="홈" src='/sis/images/main/board/navHome.png' id={stl.navHome} />
                                        &nbsp;&nbsp;
                                        <img alt="" src='/sis/images/main/board/navNext.png' id={stl.navNext} />
                                        &nbsp;&nbsp;
                                        <span id={stl.navText}>{this.state.categoryName}</span>
                                    </>}
                            </div>
                        </div>
                    </div>
                }
            </>
        );
    }
}
export default compose(
	withRouter,
	connect(
		(state) => ({
			sis: state.category,
		}),
		(dispatch) => ({
			SisMapActions: bindActionCreators(sisMapActions, dispatch),
		})
	)
)(DefaultHeader);
//export default DefaultHeader;